import { useEffect, useState } from 'react';
import userApriori from '../../../assets/images/aprioriUser.png';
import { Link } from "react-router-dom";

export default function Photo({userName, userLastName, userEmail, userPhoto, userMensajes,isAfiliate}) {
    const [name, setName] = useState(userName);
    const [lastName, setLastName] = useState(userLastName);
    const [photo, setPhoto] = useState(userPhoto);
    const [mensajes, setMensajes] = useState(userMensajes);
    const [email, setEmail] = useState(userEmail);
    const [afiliate, setAfiliate] = useState(isAfiliate);

    useEffect(() => {
        setName(userName);
        setLastName(userLastName);
        setPhoto(userPhoto);
        setMensajes(userMensajes);
        setEmail(userEmail);
        setAfiliate(isAfiliate);
    } , [userName, userLastName, userPhoto, userMensajes, userEmail, isAfiliate]);


    return(
        <div className='w-3/12 flex flex-col justify-center items-center pb-16 sm:hidden md:flex pr-6'>
           <div className="bg-white rounded-2xl border border-gray-200 shadow-sm w-full px-5 py-6 flex flex-col items-center">
           <img className="mt-1 border-4 border-gray-100 w-32 h-32 rounded-full object-cover" src={photo?photo:userApriori} alt="no photo"/>
            <h2 className='mt-5 text-2xl font-bold text-fondo text-center'>{name && name}</h2>
            <h3 className="text-gray-600">{lastName && lastName}</h3>
            <p className="text-sm text-gray-500 mt-1 text-center break-all">{email && email}</p>
            <div className="flex flex-col justify-center items-center border border-gray-200 w-full mt-5 rounded-xl overflow-hidden">
              <div className="flex flex-col justify-center bg-gray-100 w-full py-2"><h2 className="text-center text-fondo font-semibold text-sm uppercase tracking-wide">Mensajes</h2></div>
              <div className="flex flex-col justify-center items-center w-full">
                {
                  mensajes?
                    mensajes?
                      mensajes.map((mensaje, index) => {
                        if (index %2===0 ){
                          return <p key={index} className="text-center bg-white w-full p-2 text-sm text-gray-700">{mensaje}</p>
                        }else{
                          return <p key={index} className="text-center bg-gray-50 w-full p-2 text-sm text-gray-700">{mensaje}</p>
                        }
                      })
                    :
                    <p className='p-3 text-sm text-gray-500'>No tiene mensajes</p>
                  :
                  <p className='p-3 text-sm text-gray-500'>No tiene mensajes</p>
                }
              </div>
            </div>
            {
              afiliate?
                <Link to='/adminAfiliate' className='mt-6 bg-primary text-white py-2 px-4 rounded-full font-semibold hover:bg-fondo'>Administrar Afiliado</Link>
              :
              <div className='text-center mt-5'>
                <p className="text-sm text-gray-600">Ahora puede ser un Afiliado</p>
                <Link
                  to='/adminAfiliate'
                  className='mt-2 inline-block text-primary font-semibold'
                >
                  ¿Qué es ser un Afiliado?
                </Link>
              </div>
            }
           </div>

        </div>
    )
}
